import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { useObservable } from "utils/libExtend/useObservable";

export const useDefaultObservable = <T>(observable: BehaviorSubject<T>): T => useObservable<T>(observable, observable.value);
